import React from 'react';

const FormulaTable = ({ formulas, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Quantité d'articles</th>
            <th>Statut</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {formulas.map((formula) => (
            <tr key={formula.id}>
              <td>{formula.name}</td>
              <td>{formula.article_quantity}</td>
              <td>
                <span className={`badge bg-${formula.available ? 'success' : 'danger'}`}>
                  {formula.available ? 'Disponible' : 'Indisponible'}
                </span>
              </td>
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => onEdit(formula)}
                  >
                    Modifier
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(formula.documentId)}
                  >
                    Supprimer
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FormulaTable;